import React from 'react';
import Tab from './Tab';
import { useNavigate } from 'react-router-dom';

const SidePanel = ({status}) => {
  let navigate = useNavigate();

  let limited = localStorage.getItem('limited') === 'true';

  return (
    <div style={{width: '100%',
                 height: '100%',
                 color: 'white',
                 borderRight: '1px solid gray',
                 display: 'flex',
                 flexDirection: 'column',
                 justifyContent: 'space-between',
                 boxSizing: 'border-box',
                }}>
      <div style={{display: 'flex',
                   flexDirection: 'column',
                   gap: '10px',
                   overflowY: 'auto',
                   padding: '10px',
                  }}>
        {!limited && (
          <>
            <Tab text="Recent Traffic" page="/dashboard/recent-traffic" status={status['recent-traffic']}/>
            <Tab text="Recent Fraud" page="/dashboard/recent-fraud" status={status['recent-fraud']}/>
            <Tab text="Users" page="/dashboard/users" status={status['users']}/>
            <Tab text="Administrators" page="/dashboard/admins" status={status['admins']}/>
            <Tab text="No Traffic" page="/dashboard/no-traffic" status={status['no-traffic']}/>
            <Tab text="Failed Logins" page="/dashboard/failed-logins" status={status['failed-logins']}/>
            <Tab text="Recent Errors" page="/dashboard/recent-errors" status={status['recent-errors']}/>
            <Tab text="Recent Lost Records" page="/dashboard/recent-lost-records" status={status['recent-lost-records']}/>
          </>
        )}
        <Tab text="Automation Results" page="/dashboard/automation-results" status={status['automation-results']}/>
        {!limited && (
          <>
            <Tab text="Cloud" page="/dashboard/cloud" status={status['cloud']}/>
            <Tab text="Obfuscate Code" page="/dashboard/obfuscate-code" status={status['obfuscate-code']}/>
          </>
        )}
      </div>

      <div style={{padding: '10px'}}>
        <Tab text="Log out"
             onClick={() => {
               localStorage.removeItem('token');
               navigate('/');
             }} />
      </div>
    </div>
  );
}

export default SidePanel;
